import {cn} from '@cohort/shared-frontend/utils/classNames';

type TagProps = {
  className?: string;
  children: React.ReactNode;
};

const Tag: React.FC<TagProps> = ({className, children}) => (
  <div
    className={cn(
      'rounded-md border-[--xps-tag-border-color] bg-[--xps-tag-background-color] px-2 py-1 text-xs text-[--xps-tag-color]',
      className
    )}
  >
    {children}
  </div>
);

export default Tag;
